module.exports = __webpack_public_path__ + "img/mr.d1c4eda8.svg";